import { useState, useEffect, useRef } from 'react';
import { EU_COUNTRIES, getCountryName } from '../data/euCountries';
import apiClient from '../api/client';

const CACHE_KEY = 'geo_country_code';

/**
 * Grąžina vartotojo šalies kodą pagal IP (vieną kartą per sesiją).
 * Užklausa eina per backend proxy (/api/geo), kad išvengti CORS (ipapi.co neleidžia kreiptis iš naršyklės).
 * Jei šalis ne iš ES sąrašo, grąžinamas null – tuomet naudokite numatytąją (LT).
 * @param {string} language - kalba pavadinimui (lt, en, de)
 * @returns {{ countryCode: string | null, countryName: string | null, isLoading: boolean }}
 */
export function useGeoCountry(language = 'lt') {
  const [countryCode, setCountryCode] = useState(() => {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const found = EU_COUNTRIES.some((c) => c.code === cached);
        return found ? cached : null;
      }
    } catch (e) {}
    return null;
  });
  const [isLoading, setIsLoading] = useState(!countryCode);
  const fetched = useRef(!!countryCode);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    apiClient
      .get('/geo')
      .then((res) => {
        const code = (res.data?.country_code || '').toUpperCase();
        const isEU = EU_COUNTRIES.some((c) => c.code === code);
        if (isEU) {
          setCountryCode(code);
          try {
            sessionStorage.setItem(CACHE_KEY, code);
          } catch (e) {}
        }
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, []);

  const countryName = countryCode ? getCountryName(countryCode, language) : null;
  return { countryCode, countryName, isLoading };
}

export default useGeoCountry;
